"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Log = /** @class */ (function () {
    function Log() {
    }
    Log.prototype.error = function (error) {
        console.error(error);
    };
    return Log;
}());
exports.default = new Log();
